import { USER_ROLE } from '../constants/common';

const MENU_PERMISSIONS: Record<string, string[]> = {
    [USER_ROLE.ADMIN.toLowerCase()]: ['Home', 'Shop', 'Track', 'My Orders', 'Document Hub', 'Organization', 'Address Book', 'Integrations', 'Account Settings'],
    [USER_ROLE.USER.toLowerCase()]: ['Home', 'Shop', 'Track', 'My Orders', 'Document Hub', 'Address Book', 'Account Settings'],
};

export const hasMenuPermission = (userRole: string, menuName: string): boolean => {
    const normalizedRole = userRole?.toLowerCase();

    if (!normalizedRole || !MENU_PERMISSIONS[normalizedRole]) {
        return false;
    }

    return MENU_PERMISSIONS[normalizedRole].includes(menuName);
};

export const isAdmin = (userRole: string): boolean => userRole?.toLowerCase() === USER_ROLE.ADMIN;
